import { render } from "./IconError.vue?vue&type=template&id=1590a600"
import script from "./IconError.vue?vue&type=script&lang=js"
export * from "./IconError.vue?vue&type=script&lang=js"
script.render = render

export default script